import { CopyButton } from "@/components/copy";
import { WORKER_GUIDE_URL, aiStarterPrompt, DESKTOP_DOWNLOAD_URL } from "../../../desktop/src/ai-handoff-content";

// Supplement the existing Worker page without moving its status or controls.
export function GettingStarted() {
  return (
    <details className="mt-4 text-sm" data-testid="getting-started">
      <summary className="cursor-pointer text-muted-foreground">Connect Desktop & work with your AI</summary>
      <div className="mt-3 max-w-xl space-y-3">
        <p className="text-muted-foreground">
          <a className="underline" href={DESKTOP_DOWNLOAD_URL} target="_blank" rel="noreferrer">Download Desktop</a>,
          sign in with the same email, and choose Connect. Wait for Connected and Worker online.
          Signing in to this website does not connect your computer.
        </p>
        <div className="flex items-center gap-4">
          <a className="underline" href={WORKER_GUIDE_URL} target="_blank" rel="noreferrer">Explore Worker uses</a>
          <CopyButton label="Copy AI prompt" value={aiStarterPrompt()} />
        </div>
        <p className="text-muted-foreground">Choose a task and see how to work with your AI.</p>
        <details>
          <summary className="cursor-pointer text-muted-foreground">View AI prompt</summary>
          <textarea aria-label="AI starter prompt" className="mt-2 block w-full rounded-md border bg-background p-3 text-sm" rows={5} readOnly value={aiStarterPrompt()} />
        </details>
      </div>
    </details>
  );
}
